import { BookingsListResponse } from "@/models/api/bookings/BookingsList";

export default {
  page: 1,
  items: [
    // {
    //   id: 785286,
    //   recordLocator: "MMDVTS",
    //   gds: "1S",
    //   bookingIsSelected: false,
    //   contractor: "Yabimo Services Sp. z o. o. Sp. k. ",
    //   canSelect: true,
    //   bookingItems: [
    //     {
    //       id: 1246870,
    //       bookingItemGroupId: null,
    //       isRefund: false,
    //       agentId: "B7ZG * KK",
    //       creationDate: "2021-01-19T00:00:00",
    //       fareBase: 315,
    //       grandTotal: 563.99,
    //       currency: "PLN",
    //       passengerName: "KOBUS KRZYSZTOF",
    //       ticketNumber: "117-3753359306",
    //       formOfPayment: "CCAX379340134281008",
    //       itinerary: "(OSL-HAU)(HAU-OSL)",
    //       comment: "",
    //       userName: null,
    //       freeText: null,
    //       orderId: null,
    //       isVoided: false,
    //       isAutomaticallyInvoiced: false,
    //       bookingItemIsSelected: false,
    //       serviceTypeCode: "FlightForeign",
    //       name: "Bilet lotniczy zagraniczny ",
    //       status: 2,
    //       isBlockedToInvoiced: false,
    //       hasCostDocumentFile: false,
    //       canSelect: true,
    //       recordStampId: 123
    //     },
    //     {
    //       id: 1246872,
    //       bookingItemGroupId: null,
    //       isRefund: false,
    //       agentId: "B7ZG * KK",
    //       creationDate: "2021-01-19T00:00:00",
    //       fareBase: 315,
    //       grandTotal: 563.99,
    //       currency: "PLN",
    //       passengerName: "KOBUS KRZYSZTOF",
    //       ticketNumber: "117-3753359306",
    //       formOfPayment: "CCAX379340134281008",
    //       itinerary: "(OSL-HAU)(HAU-OSL)",
    //       comment: "Użyte w zamówieniu.",
    //       userName: null,
    //       freeText: null,
    //       orderId: "e54e802c-f32c-4d53-9d67-2fdde4928dfd",
    //       isVoided: false,
    //       isAutomaticallyInvoiced: false,
    //       bookingItemIsSelected: false,
    //       serviceTypeCode: "FlightForeign",
    //       name: "Bilet lotniczy zagraniczny ",
    //       status: 1,
    //       isBlockedToInvoiced: false,
    //       hasCostDocumentFile: false,
    //       canSelect: true
    //     }
    //   ],
    //   grossItems: [
    //     {
    //       total: 1127.98,
    //       currency: "PLN"
    //     }
    //   ],
    //   bookingHasAttachment: false
    // },
    // {
    //   id: 785285,
    //   recordLocator: "4SQN9J",
    //   gds: "1G",
    //   bookingIsSelected: false,
    //   isPairWithCostDocument: false,
    //   contractor: "",
    //   bookingItems: [
    //     {
    //       id: 1246866,
    //       bookingItemGroupId: null,
    //       isRefund: false,
    //       agentId: "0900PH",
    //       creationDate: "2021-01-19T23:34:00",
    //       fareBase: 287,
    //       grandTotal: 1163.19,
    //       currency: "PLN",
    //       passengerName: "MOSKAL WACLAW",
    //       ticketNumber: "235-3867936136",
    //       formOfPayment: "CASH",
    //       itinerary: "(BER-SAW)(SAW-TZX)(TZX-IST)(IST-BER)",
    //       comment: "",
    //       userName: null,
    //       freeText: null,
    //       orderId: null,
    //       isVoided: false,
    //       isAutomaticallyInvoiced: false,
    //       bookingItemIsSelected: false,
    //       serviceTypeCode: "FlightForeign",
    //       name: "Bilet lotniczy zagraniczny ",
    //       status: 0,
    //       isBlockedToInvoiced: false,
    //       hasCostDocumentFile: false,
    //       canSelect: false
    //     },
    //     {
    //       id: 1246867,
    //       bookingItemGroupId: null,
    //       isRefund: false,
    //       agentId: "0900PH",
    //       creationDate: "2021-01-19T23:34:00",
    //       fareBase: 287,
    //       grandTotal: 1163.19,
    //       currency: "PLN",
    //       passengerName: "MOSKAL MAGDALENA",
    //       ticketNumber: "235-3867936137",
    //       formOfPayment: "CASH",
    //       itinerary: "(BER-SAW)(SAW-TZX)(TZX-IST)(IST-BER)",
    //       comment: "",
    //       userName: null,
    //       freeText: null,
    //       orderId: null,
    //       isVoided: false,
    //       isAutomaticallyInvoiced: false,
    //       bookingItemIsSelected: false,
    //       serviceTypeCode: "FlightForeign",
    //       name: "Bilet lotniczy zagraniczny ",
    //       status: 0,
    //       isBlockedToInvoiced: false,
    //       hasCostDocumentFile: false,
    //       canSelect: true
    //     },
    //     {
    //       id: 1246868,
    //       bookingItemGroupId: null,
    //       isRefund: false,
    //       agentId: "0900PH",
    //       creationDate: "2021-01-19T23:34:00",
    //       fareBase: 287,
    //       grandTotal: 1163.19,
    //       currency: "PLN",
    //       passengerName: "MOSKAL WACLAW",
    //       ticketNumber: "235-3867936136",
    //       formOfPayment: "CASH",
    //       itinerary: "(BER-SAW)(SAW-TZX)(TZX-IST)(IST-BER)",
    //       comment: "Użyte w zamówieniu.",
    //       userName: null,
    //       freeText: null,
    //       orderId: "e54e802c-f32c-4d53-9d67-2fdde4928dfd",
    //       isVoided: false,
    //       isAutomaticallyInvoiced: false,
    //       bookingItemIsSelected: false,
    //       serviceTypeCode: "FlightForeign",
    //       name: "Bilet lotniczy zagraniczny ",
    //       status: 1,
    //       isBlockedToInvoiced: false,
    //       hasCostDocumentFile: false,
    //       canSelect: true
    //     },
    //     {
    //       id: 1246869,
    //       bookingItemGroupId: null,
    //       isRefund: false,
    //       agentId: "0900PH",
    //       creationDate: "2021-01-19T23:34:00",
    //       fareBase: 287,
    //       grandTotal: 1163.19,
    //       currency: "PLN",
    //       passengerName: "MOSKAL MAGDALENA",
    //       ticketNumber: "235-3867936137",
    //       formOfPayment: "CASH",
    //       itinerary: "(BER-SAW)(SAW-TZX)(TZX-IST)(IST-BER)",
    //       comment: "Użyte w zamówieniu.",
    //       userName: null,
    //       freeText: null,
    //       orderId: "e54e802c-f32c-4d53-9d67-2fdde4928dfd",
    //       isVoided: false,
    //       isAutomaticallyInvoiced: false,
    //       bookingItemIsSelected: false,
    //       serviceTypeCode: "FlightForeign",
    //       name: "Bilet lotniczy zagraniczny ",
    //       status: 1,
    //       isBlockedToInvoiced: false,
    //       hasCostDocumentFile: false,
    //       canSelect: false
    //     }
    //   ],
    //   grossItems: [
    //     {
    //       total: 4652.76,
    //       currency: "PLN"
    //     }
    //   ],
    //   bookingHasAttachment: false
    // },
    // {
    //   id: 785284,
    //   recordLocator: "4SQG4N",
    //   gds: "1G",
    //   bookingIsSelected: false,
    //   isPairWithCostDocument: false,
    //   contractor: "",
    //   bookingItems: [
    //     {
    //       id: 1246864,
    //       bookingItemGroupId: null,
    //       isRefund: false,
    //       agentId: "0900PH",
    //       creationDate: "2021-01-19T23:31:00",
    //       fareBase: 282,
    //       grandTotal: 1158.19,
    //       currency: "PLN",
    //       passengerName: "KACPEREK MARCIN",
    //       ticketNumber: "235-3867936135",
    //       formOfPayment: "CASH",
    //       itinerary: "(BER-SAW)(SAW-TZX)(TZX-IST)(IST-BER)",
    //       comment: "",
    //       userName: null,
    //       freeText: null,
    //       orderId: null,
    //       isVoided: false,
    //       isAutomaticallyInvoiced: false,
    //       bookingItemIsSelected: false,
    //       serviceTypeCode: "FlightForeign",
    //       name: "Bilet lotniczy zagraniczny ",
    //       status: 0,
    //       isBlockedToInvoiced: false,
    //       hasCostDocumentFile: false,
    //       canSelect: false
    //     },
    //     {
    //       id: 1246865,
    //       bookingItemGroupId: null,
    //       isRefund: false,
    //       agentId: "0900PH",
    //       creationDate: "2021-01-19T23:31:00",
    //       fareBase: 282,
    //       grandTotal: 1158.19,
    //       currency: "PLN",
    //       passengerName: "KACPEREK MARCIN",
    //       ticketNumber: "235-3867936135",
    //       formOfPayment: "CASH",
    //       itinerary: "(BER-SAW)(SAW-TZX)(TZX-IST)(IST-BER)",
    //       comment: "Użyte w zamówieniu.",
    //       userName: null,
    //       freeText: null,
    //       orderId: "e54e802c-f32c-4d53-9d67-2fdde4928dfd",
    //       isVoided: false,
    //       isAutomaticallyInvoiced: false,
    //       bookingItemIsSelected: false,
    //       serviceTypeCode: "FlightForeign",
    //       name: "Bilet lotniczy zagraniczny ",
    //       status: 1,
    //       isBlockedToInvoiced: false,
    //       hasCostDocumentFile: false,
    //       canSelect: true
    //     }
    //   ],
    //   grossItems: [
    //     {
    //       total: 2316.38,
    //       currency: "PLN"
    //     }
    //   ],
    //   bookingHasAttachment: false
    // },
    // {
    //   id: 785281,
    //   recordLocator: "F2BT7U",
    //   gds: "1G",
    //   bookingIsSelected: false,
    //   isPairWithCostDocument: false,
    //   contractor: "",
    //   bookingItems: [
    //     {
    //       id: 1246856,
    //       bookingItemGroupId: null,
    //       isRefund: false,
    //       agentId: "0900PH",
    //       creationDate: "2021-01-18T20:31:00",
    //       fareBase: 209,
    //       grandTotal: 1084.64,
    //       currency: "PLN",
    //       passengerName: "AFELTOWICZ MACIEJ",
    //       ticketNumber: "235-3867936132",
    //       formOfPayment: "CASH",
    //       itinerary: "(BER-SAW)(SAW-TZX)(TZX-IST)(IST-BER)",
    //       comment: "",
    //       userName: null,
    //       freeText: null,
    //       orderId: null,
    //       isVoided: true,
    //       isAutomaticallyInvoiced: false,
    //       bookingItemIsSelected: false,
    //       serviceTypeCode: "FlightForeign",
    //       name: "Bilet lotniczy zagraniczny ",
    //       status: 0,
    //       isBlockedToInvoiced: false,
    //       hasCostDocumentFile: false,
    //       canSelect: true
    //     },
    //     {
    //       id: 1246857,
    //       bookingItemGroupId: null,
    //       isRefund: false,
    //       agentId: "0900PH",
    //       creationDate: "2021-01-18T20:31:00",
    //       fareBase: 209,
    //       grandTotal: 1084.64,
    //       currency: "PLN",
    //       passengerName: "AFELTOWICZ MACIEJ",
    //       ticketNumber: "235-3867936132",
    //       formOfPayment: "CASH",
    //       itinerary: "(BER-SAW)(SAW-TZX)(TZX-IST)(IST-BER)",
    //       comment: "",
    //       userName: null,
    //       freeText: null,
    //       orderId: null,
    //       isVoided: true,
    //       isAutomaticallyInvoiced: false,
    //       bookingItemIsSelected: false,
    //       serviceTypeCode: "FlightForeign",
    //       name: "Bilet lotniczy zagraniczny ",
    //       status: 1,
    //       isBlockedToInvoiced: false,
    //       hasCostDocumentFile: false,
    //       canSelect: true
    //     },
    //     {
    //       id: 1246862,
    //       bookingItemGroupId: null,
    //       isRefund: false,
    //       agentId: "0900PH",
    //       creationDate: "2021-01-19T23:28:00",
    //       fareBase: 210,
    //       grandTotal: 1086.19,
    //       currency: "PLN",
    //       passengerName: "AFELTOWICZ MACIEJ",
    //       ticketNumber: "235-3867936134",
    //       formOfPayment: "CASH",
    //       itinerary: "(BER-SAW)(SAW-TZX)(TZX-IST)(IST-BER)",
    //       comment: "",
    //       userName: null,
    //       freeText: null,
    //       orderId: null,
    //       isVoided: false,
    //       isAutomaticallyInvoiced: false,
    //       bookingItemIsSelected: false,
    //       serviceTypeCode: "FlightForeign",
    //       name: "Bilet lotniczy zagraniczny ",
    //       status: 0,
    //       isBlockedToInvoiced: false,
    //       hasCostDocumentFile: false,
    //       canSelect: true
    //     },
    //     {
    //       id: 1246863,
    //       bookingItemGroupId: null,
    //       isRefund: false,
    //       agentId: "0900PH",
    //       creationDate: "2021-01-19T23:28:00",
    //       fareBase: 210,
    //       grandTotal: 1086.19,
    //       currency: "PLN",
    //       passengerName: "AFELTOWICZ MACIEJ",
    //       ticketNumber: "235-3867936134",
    //       formOfPayment: "CASH",
    //       itinerary: "(BER-SAW)(SAW-TZX)(TZX-IST)(IST-BER)",
    //       comment: "Użyte w zamówieniu.",
    //       userName: null,
    //       freeText: null,
    //       orderId: "e54e802c-f32c-4d53-9d67-2fdde4928dfd",
    //       isVoided: false,
    //       isAutomaticallyInvoiced: false,
    //       bookingItemIsSelected: false,
    //       serviceTypeCode: "FlightForeign",
    //       name: "Bilet lotniczy zagraniczny ",
    //       status: 1,
    //       isBlockedToInvoiced: false,
    //       hasCostDocumentFile: false,
    //       canSelect: true
    //     }
    //   ],
    //   grossItems: [
    //     {
    //       total: 4341.66,
    //       currency: "PLN"
    //     }
    //   ],
    //   bookingHasAttachment: false
    // },
    // {
    //   id: 785283,
    //   recordLocator: "4SQPB7",
    //   gds: "1G",
    //   bookingIsSelected: false,
    //   isPairWithCostDocument: false,
    //   contractor: "",
    //   bookingItems: [
    //     {
    //       id: 1246860,
    //       bookingItemGroupId: null,
    //       isRefund: false,
    //       agentId: "0900PH",
    //       creationDate: "2021-01-19T23:27:00",
    //       fareBase: 232,
    //       grandTotal: 1108.19,
    //       currency: "PLN",
    //       passengerName: "AFELTOWICZ BERNARD",
    //       ticketNumber: "235-3867936133",
    //       formOfPayment: "CASH",
    //       itinerary: "(BER-SAW)(SAW-TZX)(TZX-IST)(IST-BER)",
    //       comment: "",
    //       userName: null,
    //       freeText: null,
    //       orderId: null,
    //       isVoided: false,
    //       isAutomaticallyInvoiced: false,
    //       bookingItemIsSelected: false,
    //       serviceTypeCode: "FlightForeign",
    //       name: "Bilet lotniczy zagraniczny ",
    //       status: 0,
    //       isBlockedToInvoiced: false,
    //       isPairWithCostDocument: false,
    //       hasCostDocumentFile: false,
    //       canSelect: true
    //     },
    //     {
    //       id: 1246861,
    //       bookingItemGroupId: null,
    //       isRefund: false,
    //       agentId: "0900PH",
    //       creationDate: "2021-01-19T23:27:00",
    //       fareBase: 232,
    //       grandTotal: 1108.19,
    //       currency: "PLN",
    //       passengerName: "AFELTOWICZ BERNARD",
    //       ticketNumber: "235-3867936133",
    //       formOfPayment: "CASH",
    //       itinerary: "(BER-SAW)(SAW-TZX)(TZX-IST)(IST-BER)",
    //       comment: "Użyte w zamówieniu.",
    //       userName: null,
    //       freeText: null,
    //       orderId: "e54e802c-f32c-4d53-9d67-2fdde4928dfd",
    //       isVoided: false,
    //       isAutomaticallyInvoiced: false,
    //       bookingItemIsSelected: false,
    //       serviceTypeCode: "FlightForeign",
    //       name: "Bilet lotniczy zagraniczny ",
    //       status: 1,
    //       isBlockedToInvoiced: false,
    //       isPairWithCostDocument: false,
    //       hasCostDocumentFile: false,
    //       canSelect: true
    //     }
    //   ],
    //   grossItems: [
    //     {
    //       total: 2216.38,
    //       currency: "PLN"
    //     }
    //   ],
    //   bookingHasAttachment: false
    // },
    // {
    //   id: 785282,
    //   recordLocator: "ISEDAB",
    //   gds: "1S",
    //   bookingIsSelected: false,
    //   isPairWithCostDocument: false,
    //   contractor: "",
    //   bookingItems: [
    //     {
    //       id: 1246858,
    //       bookingItemGroupId: null,
    //       isRefund: false,
    //       agentId: "1TSJ * WS",
    //       creationDate: "2021-01-19T00:00:00",
    //       fareBase: 2108,
    //       grandTotal: 3606.77,
    //       currency: "PLN",
    //       passengerName: "MARCINKOWSKI DAWID",
    //       ticketNumber: "057-3753352947 057-3753352948",
    //       formOfPayment: "CXAX377946000003000",
    //       itinerary: "(WAW-AMS)(AMS-ATL)(ATL-PIT)(PIT-BOS)(BOS-AMS)(AMS-WAW)",
    //       comment: "",
    //       userName: null,
    //       freeText: null,
    //       orderId: null,
    //       isVoided: false,
    //       isAutomaticallyInvoiced: false,
    //       bookingItemIsSelected: false,
    //       serviceTypeCode: "Flight",
    //       name: "Bilet lotniczy międzynarodowy transkontynentalny",
    //       status: 0,
    //       isBlockedToInvoiced: false,
    //       hasCostDocumentFile: false,
    //       canSelect: true
    //     },
    //     {
    //       id: 1246859,
    //       bookingItemGroupId: null,
    //       isRefund: false,
    //       agentId: "1TSJ * WS",
    //       creationDate: "2021-01-19T00:00:00",
    //       fareBase: 2108,
    //       grandTotal: 3606.77,
    //       currency: "PLN",
    //       passengerName: "MARCINKOWSKI DAWID",
    //       ticketNumber: "057-3753352947 057-3753352948",
    //       formOfPayment: "CXAX377946000003000",
    //       itinerary: "(WAW-AMS)(AMS-ATL)(ATL-PIT)(PIT-BOS)(BOS-AMS)(AMS-WAW)",
    //       comment: "Użyte w zamówieniu.",
    //       userName: null,
    //       freeText: null,
    //       orderId: "e54e802c-f32c-4d53-9d67-2fdde4928dfd",
    //       isVoided: false,
    //       isAutomaticallyInvoiced: false,
    //       bookingItemIsSelected: false,
    //       serviceTypeCode: "Flight",
    //       name: "Bilet lotniczy międzynarodowy transkontynentalny",
    //       status: 1,
    //       isBlockedToInvoiced: false,
    //       hasCostDocumentFile: false,
    //       canSelect: true
    //     }
    //   ],
    //   grossItems: [
    //     {
    //       total: 7213.54,
    //       currency: "PLN"
    //     }
    //   ],
    //   bookingHasAttachment: false
    // },
    // {
    //   id: 785279,
    //   recordLocator: "eIC108290897#1",
    //   gds: "1R",
    //   bookingIsSelected: false,
    //   isPairWithCostDocument: false,
    //   contractor: "",
    //   bookingItems: [
    //     {
    //       id: 1246854,
    //       bookingItemGroupId: null,
    //       isRefund: false,
    //       agentId: null,
    //       creationDate: "2021-01-18T20:39:37",
    //       fareBase: 17.9,
    //       grandTotal: 17.9,
    //       currency: "PLN",
    //       passengerName: "MIGA MATEUSZ",
    //       ticketNumber: "eIC108290897",
    //       formOfPayment: null,
    //       itinerary: null,
    //       comment: "",
    //       userName: null,
    //       freeText: null,
    //       orderId: null,
    //       isVoided: false,
    //       isAutomaticallyInvoiced: false,
    //       bookingItemIsSelected: false,
    //       serviceTypeCode: "RailDomesticAgency",
    //       name: "Bilet kolejowy agencyjny kraj.",
    //       status: 0,
    //       isBlockedToInvoiced: false,
    //       hasCostDocumentFile: false,
    //       canSelect: true
    //     }
    //   ],
    //   grossItems: [
    //     {
    //       total: 17.9,
    //       currency: "PLN"
    //     }
    //   ],
    //   bookingHasAttachment: false
    // },
    // {
    //   id: 785280,
    //   recordLocator: "eIC108290960#1",
    //   gds: "1R",
    //   bookingIsSelected: false,
    //   isPairWithCostDocument: false,
    //   contractor: "",
    //   bookingItems: [
    //     {
    //       id: 1246855,
    //       bookingItemGroupId: null,
    //       isRefund: false,
    //       agentId: null,
    //       creationDate: "2021-01-18T20:41:29",
    //       fareBase: 17.9,
    //       grandTotal: 17.9,
    //       currency: "PLN",
    //       passengerName: "MIGA MATEUSZ",
    //       ticketNumber: "eIC108290960",
    //       formOfPayment: null,
    //       itinerary: null,
    //       comment: "",
    //       userName: null,
    //       freeText: null,
    //       orderId: null,
    //       isVoided: false,
    //       isAutomaticallyInvoiced: false,
    //       bookingItemIsSelected: false,
    //       serviceTypeCode: "RailDomesticAgency",
    //       name: "Bilet kolejowy agencyjny kraj.",
    //       status: 0,
    //       isBlockedToInvoiced: false,
    //       hasCostDocumentFile: false,
    //       canSelect: true
    //     }
    //   ],
    //   grossItems: [
    //     {
    //       total: 17.9,
    //       currency: "PLN"
    //     }
    //   ],
    //   bookingHasAttachment: false
    // },
    // {
    //   id: 785278,
    //   recordLocator: "V9H3SY#1",
    //   gds: "LC",
    //   bookingIsSelected: false,
    //   contractor: "",
    //   bookingItems: [
    //     {
    //       id: 1246853,
    //       bookingItemGroupId: null,
    //       isRefund: false,
    //       agentId: null,
    //       creationDate: "2021-01-18T00:00:00",
    //       fareBase: 189,
    //       grandTotal: 524,
    //       currency: "NOK",
    //       passengerName: "NAPIERAJ KONRAD",
    //       ticketNumber: "V9H3SY",
    //       formOfPayment: "M4",
    //       itinerary: "(OSL-KRK)",
    //       comment: "",
    //       userName: null,
    //       freeText: null,
    //       orderId: null,
    //       isVoided: false,
    //       isAutomaticallyInvoiced: false,
    //       bookingItemIsSelected: false,
    //       serviceTypeCode: "LCC",
    //       name: "Tanie linie lotnicze międzynarodowe",
    //       status: 0,
    //       isBlockedToInvoiced: false,
    //       hasCostDocumentFile: false,
    //       canSelect: true
    //     }
    //   ],
    //   grossItems: [
    //     {
    //       total: 524,
    //       currency: "NOK"
    //     }
    //   ],
    //   bookingHasAttachment: false
    // },
    // {
    //   id: 785277,
    //   recordLocator: "VGNBHI",
    //   gds: "1S",
    //   bookingIsSelected: false,
    //   isPairWithCostDocument: false,
    //   contractor: "Yabimo Services Sp. z o. o. Sp. k. ",
    //   bookingItems: [
    //     {
    //       id: 1246851,
    //       bookingItemGroupId: null,
    //       isRefund: false,
    //       agentId: "B7ZG * MO",
    //       creationDate: "2021-01-18T00:00:00",
    //       fareBase: 351,
    //       grandTotal: 605.68,
    //       currency: "PLN",
    //       passengerName: "NAPIERAJ KONRAD",
    //       ticketNumber: "117-3753359304",
    //       formOfPayment: "CCAX379340134271009",
    //       itinerary: "(HAU-BGO)(BGO-TRF)",
    //       comment: "",
    //       userName: null,
    //       freeText: null,
    //       orderId: null,
    //       isVoided: false,
    //       isAutomaticallyInvoiced: false,
    //       bookingItemIsSelected: false,
    //       serviceTypeCode: "FlightForeign",
    //       name: "Bilet lotniczy zagraniczny ",
    //       status: 2,
    //       isBlockedToInvoiced: false,
    //       hasCostDocumentFile: false,
    //       canSelect: true
    //     },
    //     {
    //       id: 1246852,
    //       bookingItemGroupId: null,
    //       isRefund: false,
    //       agentId: "B7ZG * MO",
    //       creationDate: "2021-01-18T00:00:00",
    //       fareBase: 351,
    //       grandTotal: 605.68,
    //       currency: "PLN",
    //       passengerName: "NAPIERAJ KONRAD",
    //       ticketNumber: "117-3753359304",
    //       formOfPayment: "CCAX379340134271009",
    //       itinerary: "(HAU-BGO)(BGO-TRF)",
    //       comment: "Użyte w zamówieniu.",
    //       userName: null,
    //       freeText: null,
    //       orderId: "7a26514f-6466-4428-b8f1-0ce813e742b4",
    //       isVoided: false,
    //       isAutomaticallyInvoiced: false,
    //       bookingItemIsSelected: false,
    //       serviceTypeCode: "FlightForeign",
    //       name: "Bilet lotniczy zagraniczny ",
    //       status: 1,
    //       isBlockedToInvoiced: false,
    //       hasCostDocumentFile: false,
    //       canSelect: true
    //     }
    //   ],
    //   grossItems: [
    //     {
    //       total: 1211.36,
    //       currency: "PLN"
    //     }
    //   ],
    //   bookingHasAttachment: false
    // }
  ],
  totalCount: 1618,
} as BookingsListResponse;
